import React, {useEffect} from 'react';
import {useTitle} from "../../../contexts/title";
import BackOrderedGrid from '../../../features/cfi/back-ordered-grid/components/BackOrderedGrid';

export default function BackOrderedPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Back Ordered')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<BackOrderedGrid />
			</div>
		</React.Fragment>
	)
} 
